import { Box, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { useWorkSchedule } from '../context/useTimeClock';
import { WorkScheduleForm } from '../components/TimeClockForm/TimeClockForm';

export default function WorkScheduleFormPage() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { id } = useParams();
  const { workScheduleData, isDataLoading } = useWorkSchedule();

  const isEditing = !!id;

  if (isDataLoading && isEditing) {
    return (
      <Box style={{ 
        background: theme.palette.background.paper, 
        borderRadius: 16, 
        padding: 32, 
        boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)', 
        maxWidth: '100%', 
        margin: '0 auto' 
      }}>
        <Typography>Carregando...</Typography>
      </Box>
    );
  }

  return (
    <Box style={{ 
      background: theme.palette.background.paper, 
      borderRadius: 16, 
      padding: 32, 
      boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)', 
      maxWidth: '100%', 
      margin: '0 auto' 
    }}>
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate('/timeclock')}
          variant="outlined"
        >
          Voltar
        </Button>
        <Typography variant="h4" color={theme.palette.text.primary}>
          {isEditing ? 'Editar Jornada' : 'Nova Jornada'}
        </Typography>
      </Box>

      {/* Form */}
      <WorkScheduleForm />
    </Box>
  );
} 